/** Consultas RFB (SERPRO): CNPJ, CPF, Faturamento, CCIR e histórico. */
import { Link, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Sec, Tabs } from '../ui/layout';
import { AbaConsulta, PaginaConsultas } from '../telas/serpro/consultas';
import { useSerproCredenciais } from '../telas/serpro/config';

export const Route = createFileRoute('/_app/consultas')({ validateSearch: z.object({ aba: AbaConsulta.optional() }), component: Consultas });

function Consultas() {
  const s = Route.useSearch();
  const nav = Route.useNavigate();
  const aba = s.aba ?? 'cnpj';
  const cred = useSerproCredenciais();
  const ativa = (api: string) => !!cred.data?.find((c) => c.api === api)?.ativo;
  return (
    <>
      <div className="topbar"><div><h1>Consultas RFB</h1><div className="sub">APIs do SERPRO — cada consulta com retorno é bilhetada no contrato</div></div></div>
      <div className="conteudo">
        <Tabs valor={aba} onChange={(v) => void nav({ search: { aba: v } })} itens={[{ id: 'cnpj', rotulo: `CNPJ${ativa('CNPJ') ? '' : ' (desligada)'}` }, { id: 'cpf', rotulo: `CPF${ativa('CPF') ? '' : ' (desligada)'}` }, { id: 'faturamento', rotulo: `Faturamento${ativa('FATURAMENTO') ? '' : ' (desligada)'}` }, { id: 'ccir', rotulo: `CCIR${ativa('CCIR') ? '' : ' (desligada)'}` }, { id: 'historico', rotulo: 'Histórico' }]} />
        <Sec titulo={aba === 'historico' ? 'Histórico de consultas' : 'Consulta avulsa'} sub={aba === 'historico' ? 'tudo o que foi consultado, por quem e o resultado' : 'sem vínculo com cliente; para gravar na ficha, consulte pela aba Receita Federal do cliente'}>
          {cred.data && aba !== 'historico' && !ativa({ cnpj: 'CNPJ', cpf: 'CPF', faturamento: 'FATURAMENTO', ccir: 'CCIR' }[aba]) ? <div className="alerta info">Esta API está desligada. Um administrador ativa em <Link to="/configuracoes">Configurações</Link> (seção APIs de consulta SERPRO).</div> : <PaginaConsultas aba={aba} />}
        </Sec>
      </div>
    </>
  );
}
